import { Table, Column, Cell, ColumnHeaderCell } from 'callahan-react'
import React from 'react'

class DevKeysTable extends React.Component {
  renderCell = (index, prop, modifier) => {
    const { displayData } = this.props
    const data = displayData[index]
    return (
      <Cell key={data.apiKey} className="networks-cell ui-cell">
        <h5 className="cell-header">
          {typeof modifier !== 'undefined' ? modifier(data[prop]) : data[prop]}
        </h5>
      </Cell>
    )
  }

  renderKeyCell = rowIndex => this.renderCell(rowIndex, 'apiKey')

  renderSecretCell = rowIndex => this.renderCell(rowIndex, 'apiSecret')

  render() {
    const { displayData } = this.props
    const cols = [
      {
        title: 'API Key',
        key: 'key',
        render: this.renderKeyCell
      },
      {
        title: 'API Secret',
        key: 'secret',
        render: this.renderSecretCell
      }
    ].map(col => {
      return (
        <Column
          header={
            <ColumnHeaderCell>
              <h4>{col.title}</h4>
            </ColumnHeaderCell>
          }
          key={col.key}
          renderCell={col.render}
          grow={true}
        />
      )
    })

    return (
      <div>
        <div className="table-holder">
          <Table displayData={displayData} grow={true}>
            {cols}
          </Table>
        </div>
      </div>
    )
  }
}
export default DevKeysTable



// WEBPACK FOOTER //
// ./src/pages/UserInfo/DevKeysTable.js